// @flow

import styled from 'styled-components';

export const IconWrapper = styled.div`
  padding-left: 2%;
`;
